// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
import amplitude from 'amplitude-js';

const RatesApi = ApiFactory.get('rates');

const fetchAll = async ({ commit, dispatch }, qs) => {
  const { data } = await RatesApi.getAll(qs);
  commit('SET_DATA', data);
  dispatch('filterSaved');
};

const filterSaved = ({ commit, state }) => {
  commit('SET_SAVED', state.data.filter(item => item.saved));
};

const create = async ({ commit }, payload) => {
  const { data } = await RatesApi.post(payload);
  amplitude.getInstance().logEvent('CREATE_RATE');
  commit('PUSH_DATA', data);
  commit('PUSH_SAVED', data);
};

const update = async ({ commit }, payload) => {
  const { data } = await RatesApi.update(payload.id, payload);
  amplitude.getInstance().logEvent('UPDATE_RATE');
  commit('UPDATE_BY_ID', data, payload.id);
};

export default {
  fetchAll,
  filterSaved,
  create,
  update
};
